import { useEffect, useRef, useState } from 'react';

const WHATSAPP_URL = 'https://wa.me/5535997383261?text=Ol%C3%A1%2C%20vim%20pelo%20site%20e%20gostaria%20de%20falar%20com%20o%20advogado%20criminalista%20Patrick%20Serafini';

const PROBLEM_TAGS = [
  'Perda de liberdade',
  'Complicações processuais',
  'Desgaste emocional',
];

const SOLUTION_CARDS = [
  {
    title: 'Decisões sem acompanhamento',
    desc: 'Tomar decisões sem orientação jurídica especializada pode comprometer todo o processo e seus direitos.',
  },
  {
    title: 'Documentação incompleta',
    desc: 'A falta de documentação adequada e prazos cumpridos pode enfraquecer a defesa.',
  },
  {
    title: 'Desgaste emocional',
    desc: 'O estresse afeta o julgamento, levando a escolhas que não protegem seus interesses.',
  },
];

export default function ProblemSolutionSection() {
  const sectionRef = useRef<HTMLElement>(null);
  const [inView, setInView] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) setInView(true);
      },
      { threshold: 0.15 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section ref={sectionRef} className="bg-white py-16 md:py-28 px-4 md:px-6 lg:px-10">
      <div className="max-w-6xl mx-auto">
        {/* Problem */}
        <div
          className={`transition-all duration-700 ${
            inView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
          }`}
        >
          <span className="font-montserrat text-grey text-xs md:text-sm tracking-widest uppercase">
            O Desafio
          </span>
          <h2 className="font-cinzel font-bold text-navy text-2xl md:text-4xl lg:text-5xl mt-3 leading-tight">
            O risco de agir
            <br />
            sem orientação especializada
          </h2>
          <div className="flex flex-wrap gap-3 mt-5">
            {PROBLEM_TAGS.map((tag, i) => (
              <span
                key={i}
                className="font-montserrat text-sm px-4 py-2 rounded-full border border-navy text-navy"
              >
                {tag}
              </span>
            ))}
          </div>
          <p className="font-montserrat font-light text-grey text-base md:text-lg mt-6 max-w-2xl leading-relaxed">
            Situações criminais urgentes exigem decisões rápidas, mas sem orientação jurídica
            especializada, o risco de perda de liberdade, complicações processuais e desgaste
            emocional aumenta drasticamente.
          </p>
        </div>

        {/* Solution Card */}
        <div
          className={`mt-12 md:mt-16 bg-navy rounded-3xl p-6 md:p-10 lg:p-12 transition-all duration-700 delay-200 ${
            inView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
          }`}
        >
          <span className="font-montserrat font-medium text-green-cta text-xs tracking-widest uppercase">
            A Solução
          </span>
          <h3 className="font-cinzel font-bold text-white text-xl md:text-2xl lg:text-3xl mt-3">
            Defesa estratégica e imediata
          </h3>
          <p className="font-montserrat font-light text-grey-muted text-base mt-4 max-w-2xl leading-relaxed">
            Orientação jurídica clara e imediata, estratégias de defesa adaptadas ao seu caso,
            acompanhamento completo em delegacia, audiências e tribunais. Proteja seus direitos
            com quem entende de Direito Criminal.
          </p>

          {/* Solution mini cards */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-8">
            {SOLUTION_CARDS.map((card, i) => (
              <div
                key={i}
                className="bg-navy-light border border-navy-border rounded-2xl p-5"
              >
                <h4 className="font-cinzel font-semibold text-white text-base">
                  {card.title}
                </h4>
                <p className="font-montserrat font-light text-grey-light text-sm mt-2 leading-relaxed">
                  {card.desc}
                </p>
              </div>
            ))}
          </div>

          <div className="mt-8 flex justify-center">
            <a
              href={WHATSAPP_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center gap-2 bg-green-cta text-navy font-montserrat font-semibold text-xs md:text-sm px-4 md:px-6 py-3 rounded-full hover:opacity-90 transition-opacity whitespace-nowrap w-full sm:w-auto"
            >
              <i className="ri-whatsapp-line w-4 h-4 flex items-center justify-center" />
              Falar com o Advogado no WhatsApp
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}